import React, { Component } from 'react';
import axios from "axios";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import moment from "moment";
import css from './WorkOrder.module.scss';
import Alert from "../../components/Alert/Alert";
import { faTimes, faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _, { forEach } from 'lodash';

const SafetyAudit = class extends Component {
    // ---------- class fields: ----------
    workOrderId = this.props.match.params.id;
    source = axios.CancelToken.source();

    postReqWO = {
        "limit": 1,
        "skip": 0,
        "fields": [
            "Id",
            "Name",
            "Date__c",
            "Start_Time__c",
            "Duration__c",
            "Work_Types__c",
            "Customer_Confirmed__c",
            "Clocked_Start__c",
            "Clocked_End__c",
            "Safety_Audit_Start__c",
            "Safety_Audit_End__c",
            "Safety_Auditor__c",
            "Safety_Auditor__r.Name",
            "Safety_Audit_Passed__c",
            "Departure_Time__c",
            "Opportunity__c",
            "Opportunity__r.Street__c",
            "Opportunity__r.City__c",
            "Opportunity__r.State__c",
            "Opportunity__r.Zip__c",
            "Opportunity__r.Notes_for_Field__c",
            "Opportunity__r.Any_Code_Gates_Animals__c",
            "Assigned_Field_Team__c",
            "Assigned_Field_Team__r.Tech_1__c",
            "Assigned_Field_Team__r.Tech_1__r.Name",
            "Assigned_Field_Team__r.Tech_2__c",
            "Assigned_Field_Team__r.Tech_2__r.Name",
            "Assigned_Field_Team__r.Tech_3__c",
            "Assigned_Field_Team__r.Tech_3__r.Name",
            "Assigned_Field_Team__r.Tech_4__c",
            "Assigned_Field_Team__r.Tech_4__r.Name",
            "Assigned_Field_Team__r.Tech_5__c",
            "Assigned_Field_Team__r.Tech_5__r.Name",
            "Pre_Install_Safety_Form__c",
            'Harnessed_Anchored__c',
            "Hard_Hats__c",
            "Safety_Goggles__c",
            "Ladder_Securement__c",
            "Gutter_Protection__c",
            "Work_Zone_Perimeter__c",
            "Vehicles_Coned_Off__c",
            "Shaded_Area__c",
            "Water_Available__c",
            "Customer_Aware_of_Work_Zone__c",
            "Knowledge_Check__c",
            "First_Aid_Kit__c",
            "Fire_Extinguisher__c",
            "Safety_Audit_Comments__c"
        ],
        "where": {
            "Id": this.workOrderId
        }
    };

    // ---------- state: ----------
    state = {
        fieldJobId: '',
        workOrder: {},
        shouldDisableStartButton: false,
        shouldShowAlert: false,
        fieldTeam: [],
        viewMode: 'workOrder', // workOrder / auditView / auditEdit
        isEditing: false,
        mappedFields: [
            // Fields: name, apiName, type, required (by default = true).
            {name:"Is the Pre-Install Safety Form accurate and complete?",apiName:'Pre_Install_Safety_Form__c',type:'yesNoNa'},
            {name:"Are all technicians on the roof wearing a harness and attached via a secure anchor?",apiName:'Harnessed_Anchored__c',type:'yesNoNa'},
            {name:"Are hard hats being worn by each technician working in the fall zone?",apiName:'Hard_Hats__c',type:'yesNoNa'},
            {name:"Are technicians using safety goggles while using power tools or working on electrical equipment?",apiName:'Safety_Goggles__c',type:'yesNoNa'},
            {name:"Is the ladder securely attached to the eave via ladder strap or ladder stabilizer?",apiName:'Ladder_Securement__c',type:'yesNoNa'},
            {name:"Are the gutters protected by a gutter guard?",apiName:'Gutter_Protection__c',type:'yesNoNa'},
            {name:"Is the work zone labeled by use of caution tape, cones, signs, etc.?",apiName:'Work_Zone_Perimeter__c',type:'yesNoNa'},
            {name:"Are warning cones placed around each company vehicle?",apiName:'Vehicles_Coned_Off__c',type:'yesNoNa'},
            {name:"Is there an adequate shaded area (pop up tent, cab of van, etc.) for breaks?",apiName:'Shaded_Area__c',type:'yesNoNa'},
            {name:"Is water available for each technician?",apiName:'Water_Available__c',type:'yesNoNa'},
            {name:"Has the customer been instructed to stay out of the work zone?",apiName:'Customer_Aware_of_Work_Zone__c',type:'yesNoNa'},
            {name:"Knowledge check - roles, fire extinguisher, first aid kit, rescue plan (all 4 to pass)",apiName:'Knowledge_Check__c',type:'yesNoNa'},
            {name:"Is the first aid kit on the vehicle? (check expiration date)",apiName:'First_Aid_Kit__c',type:'yesNoNa'},
            {name:"Is the fire extinguisher on the vehicle? (check expiration date)",apiName:'Fire_Extinguisher__c',type:'yesNoNa'},
            {name:"Any comments / corrective actions?",apiName:'Safety_Audit_Comments__c',type:'textarea', required:false}
        ]
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        this.getWorkOrder();
    }

    getWorkOrder() {
        axios.post(
            '/sf/WorkOrder/findNo',
            this.postReqWO,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];
                const opp = data.Opportunity__r;

                // Formatting related and formula fields
                data.FullAddress = `${opp.Street__c}, ${opp.City__c}, ${opp.State__c}  ${opp.Zip__c}`;
                data.formattedTime = moment.utc(data.Start_Time__c, "HH:mm:ssZ").format("h:mm A");
                data.formattedDepTime = moment.utc(data.Departure_Time__c, "HH:mm:ssZ").format("h:mm A");
                data.fieldNotes = opp.Notes_for_Field__c;
                data.Any_Code_Gates_Animals__c = opp.Any_Code_Gates_Animals__c;

                // Duration Logic to make it readable
                let hours = Math.floor(data.Duration__c / 60);
                let remainingMinutes = (data.Duration__c % 60).toFixed(2);
                if (hours > 0 && remainingMinutes > 0) {
                    data.duration = `${hours}h ${remainingMinutes}m`;
                } else if (hours > 0) {
                    data.duration = `${hours}h`;
                } else {
                    data.duration = `${remainingMinutes}m`;
                }

                // Field team array
                const fieldTeam = [];
                if (data.Assigned_Field_Team__r.Tech_1__r) {
                    fieldTeam.push(data.Assigned_Field_Team__r.Tech_1__r);
                }
                if (data.Assigned_Field_Team__r.Tech_2__r) {
                    fieldTeam.push(data.Assigned_Field_Team__r.Tech_2__r);
                }
                if (data.Assigned_Field_Team__r.Tech_3__r) {
                    fieldTeam.push(data.Assigned_Field_Team__r.Tech_3__r);
                }
                if (data.Assigned_Field_Team__r.Tech_4__r) {
                    fieldTeam.push(data.Assigned_Field_Team__r.Tech_4__r);
                }
                if (data.Assigned_Field_Team__r.Tech_5__r) {
                    fieldTeam.push(data.Assigned_Field_Team__r.Tech_5__r);
                }

                this.setState({workOrder: data, fieldTeam});
            })
            .catch(err => console.log('POST Error:\n', err));
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    changeViewMode(viewMode) {
        this.setState({viewMode});
        window.scrollTo(0, 0);
    }

    startOnClick = () => {
        this.setState({shouldDisableStartButton: true});

        axios.put(
            '/sf/WorkOrder/update',
            {
                Id: this.workOrderId,
                Safety_Audit_Start__c: moment().format('YYYY-MM-DDTHH:mm:ssZ')
            })
        .then(() => {
            this.getWorkOrder();
            this.changeViewMode('auditEdit');
        })
        .catch(err => {
            console.log('PUT Error Work Order:\n', err);
            this.setState({shouldDisableStartButton: false})
        });
    };

    saveOnClick = () => {
        this.saveAuditFields(false);
    };

    finishOnClick = () => {
        this.saveAuditFields(true);
    };

    cancelOnClick = () => {
        this.getWorkOrder();
        this.changeViewMode('workOrder')
    }

    saveAuditFields(finishJob) {
        this.setState({shouldDisableStartButton: true});
        let payload = {Id: this.workOrderId};
        let allowFinish = true;

        if(finishJob === true){
            payload.Safety_Audit_End__c = moment().format('YYYY-MM-DDTHH:mm:ssZ');
        }

        this.state.mappedFields.forEach(field => {
            let fieldValue = this.state.workOrder[field.apiName];
            payload[field.apiName] = fieldValue;

            if(!fieldValue && field.required !== false){
                allowFinish = false;
            }
        })
        
        if(!finishJob || allowFinish){
            axios.put('/sf/WorkOrder/update', payload)
            .then(() => {
                this.getWorkOrder();
                this.changeViewMode('auditView');
            })
            .catch(err => {
                console.log('PUT Error Work Order:\n', err);
                this.setState({shouldDisableStartButton: false})
            });
        } else {
            this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out Required Fields (*) Before Ending Audit'})
        }
    }

    getInput = (inputType, field, fieldProps, fieldStateOptions) => {
        switch (inputType) {
            case 'yesNoNa':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.fieldOnChange(field, event.target.value)}>
                            <option disabled value=""></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                            <option value="N/A">N/A</option>
                        </select>
                    </div>
                );
            case 'picklist':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.fieldOnChange(field, event.target.value)}>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'text':
                return(
                    <div className="pb-4">
                        <input
                            type="text"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.fieldOnChange(field, event.target.value)}
                        />
                    </div>
                );
            case 'checkbox':
                return(
                    <div className="pb-4">
                        <input
                            type="checkbox"
                            defaultChecked={fieldProps ? fieldProps : false}
                            onChange={(event) => this.fieldOnChange(field, !event.target.defaultChecked)}
                        />
                    </div>
                );
            case 'textarea':
                return(
                    <div className="pb-4">
                        <textarea
                            rows="5"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.fieldOnChange(field, event.target.value)}
                        />
                    </div>
                );
            default:
                return(
                    <div>
                        Not
                    </div>
                );
        };
    }

    // Handles updating the newly entered value for the work order
    // and setting state copying over the edited field
    fieldOnChange = (fieldName, value) => {
        const editFields = _.cloneDeep(this.state.workOrder);
        editFields[fieldName] = value;
        this.setState({workOrder:editFields});
    };
    

    render() {
        return (
            <div className={css.ScheduledJobDetails}>
                <Alert showAlert={this.state.shouldShowAlert}>{this.state.alertMessage} <FontAwesomeIcon icon={faTimes} onClick={() => {this.setState({shouldShowAlert: false, alertMessage: ''});}}/></Alert>
                <div className = {this.state.viewMode === 'workOrder' ? '' : 'd-none'}>
                    <h1 className="my-0">
                        <a
                            className="text-white"
                            href={`https://v3electric.my.site.com/frontendOps/s/detail/${this.state.workOrder.Opportunity__c}`}
                        >{this.state.workOrder.Name}</a>
                    </h1>
                    {/* <h2 className="my-0">{this.state.workOrder.Work_Types__c}</h2> */}
                    <h2 className="my-0">Site Safety Audit</h2>

                    <div className="row mt-4">
                        <div className="col-12 col-sm-6">
                            <div>
                                <a
                                    className="text-primary font-weight-bold"
                                    href={`https://www.google.com/maps/search/?api=1&query=${this.state.workOrder.FullAddress}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >{this.state.workOrder.FullAddress}</a>
                            </div>
                            <h4 className="mt-1">Full Address</h4>
                        </div>
                    </div>

                    {/* ---------- Details Table: ---------- */}
                    <div className="mt-5">
                        <h2>Job Details</h2>
                        <table className={css.ScheduledJobDetails__Table}>
                            <tbody>
                                <tr>
                                    <td>Safety Auditor</td>
                                    <td className="font-weight-bold">
                                        {this.state.workOrder.Safety_Auditor__c ? this.state.workOrder.Safety_Auditor__r.Name : "---"}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Date</td>
                                    <td className="font-weight-bold">{moment(this.state.workOrder.Date__c).format('ddd, MMM D, YYYY')}</td>
                                </tr>
                                <tr>
                                    <td>Work Start Time</td>
                                    <td className="font-weight-bold">{this.state.workOrder.formattedTime}</td>
                                </tr>
                                <tr>
                                    <td>Work Duration</td>
                                    <td className="font-weight-bold">{this.state.workOrder.duration}</td>
                                </tr>
                                <tr>
                                    <td>Work Types</td>
                                    <td className="font-weight-bold">{this.state.workOrder.Work_Types__c}</td>
                                </tr>
                                <tr>
                                    <td>CU Preferences/Access Info</td>
                                    <td className="font-weight-bold">{this.state.workOrder.Any_Code_Gates_Animals__c ? this.state.workOrder.Any_Code_Gates_Animals__c : '---'}</td>
                                </tr>
                                <tr>
                                    <td>Customer Confirmed</td>
                                    <td className="font-weight-bold">{this.state.workOrder.Customer_Confirmed__c ? moment(this.state.workOrder.Customer_Confirmed__c).format('MM/D/YY') : "---"}</td>
                                </tr>
                                <tr>
                                    <td>Notes for Field</td>
                                    <td className="font-weight-bold overflow-auto"><textarea rows="8" value={this.state.workOrder.fieldNotes}/></td>
                                </tr>
                                {
                                    this.state.showServiceInfo ?
                                    <tr>
                                        <td>Service Case Description</td>
                                        <td className="font-weight-bold overflow-auto"><textarea rows="8" value={this.state.workOrder.Case__c ? this.state.workOrder.Case__r.Description : ''}/></td>
                                    </tr>
                                    :
                                    null
                                }
                                <tr>
                                    <td>Audit Clocked Start</td>
                                    <td className="font-weight-bold">
                                        {this.state.workOrder.Safety_Audit_Start__c ? moment(this.state.workOrder.Safety_Audit_Start__c).format('MM/D/YY h:mm A') : "---"}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Audit Clocked End</td>
                                    <td className="font-weight-bold">
                                        {this.state.workOrder.Safety_Audit_End__c ? moment(this.state.workOrder.Safety_Audit_End__c).format('MM/D/YY h:mm A') : "---"}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Safety Audit Passed?</td>
                                    <td className="font-weight-bold">
                                        {this.state.workOrder.Safety_Audit_Passed__c ? this.state.workOrder.Safety_Audit_Passed__c : "---"}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Field Team Table */}
                    <div className='mt-5'>
                        <h2>Field Team</h2>
                        <table>
                            <tbody>
                            {
                                this.state.fieldTeam.map((tech, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{tech.Name}</td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>

                    <div className='mt-5'>
                        {/* ---------- Start/Edit Job: ---------- */}
                        <div className={this.state.workOrder.Safety_Audit_Start__c !== null ? 'd-none' : 'mt-3'}>
                            <button className="btn btn-primary w-100 text-md" type="button" onClick={() => this.startOnClick()} disabled={this.state.shouldDisableStartButton}>Start Audit</button>
                        </div>
                        <div className={this.state.workOrder.Safety_Audit_Start__c !== null ? 'mt-3' : 'd-none'}> 
                            <button className="btn btn-primary w-100 text-md" type="button" onClick={() => this.changeViewMode('auditView')}>Edit Audit</button>
                        </div>

                        {/* ---------- Photo Pack: ---------- */}
                        <div className='mt-3'>
                            <Link to={`/photoPack/safetyAudit/${this.state.workOrder.Id}/${this.state.workOrder.Opportunity__c}`}>
                                <button className="btn btn-primary w-100 text-md" type="button">Safety Audit Photo Pack</button>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className={this.state.viewMode === 'workOrder' ? 'd-none' : ''}>
                    <div className="d-flex justify-content-between mt-5 mb-4">
                        <button className="btn btn-outline" type="button" onClick={() => this.cancelOnClick()}>Cancel</button>
        
                        <div className='text-right'>
                            <button className={this.state.viewMode === 'auditEdit' ? "d-none" : "btn btn-outline"} type="button" onClick={() => this.changeViewMode('auditEdit')}>Edit</button>
                            <button className={this.state.viewMode === 'auditEdit' ? "btn btn-outline" : "d-none"} type="button" onClick={() => this.saveOnClick()}>Save</button>
                        </div>
                    </div>
                    <div className={this.state.workOrder.Safety_Audit_End__c ? 'd-none' : ''}>
                        <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.finishOnClick()}>Finish Audit</button>
                    </div>
                    <div className={this.state.workOrder.Safety_Audit_End__c ? '' : 'd-none'}>
                        <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.saveFields('end')}>Audit Completed</button>
                    </div>

                    <div className="text-white mt-3">
                        <h2 className="pt-4 pb-2">Site Safety Audit</h2>
                        {
                        this.state.viewMode === 'auditEdit' ?
                        this.state.mappedFields.map((field) => {
                            return (
                                <div key={field}>
                                    <div>
                                        <label htmlFor={field.apiName}>{field.name}{field.required !== false ? '*' : ''}</label>
                                        {
                                            field.type !== 'picklist' && field.type !== 'multiPicklist' ?
                                            <>
                                                {this.getInput(field.type, field.apiName, this.state.workOrder[field.apiName])}
                                            </>
                                            :
                                            <>
                                                {this.getInput(field.type, field.apiName, this.state.workOrder[field.apiName], this.pickfields[field.apiName].picklistValues)}
                                            </>
                                        }
                                    </div>
                                </div>
                            )
                        })

                        : this.state.viewMode === 'auditView' ?

                        this.state.mappedFields.map((field) => {
                            return (
                                <div key={field} className='mb-3'>
                                    <div>
                                        <label className="text-white col-sm-5 col-12 m-0 py-2">{field.name}</label>
                                        <div className="d-inline col-sm-7 col-12">{this.state.workOrder[field.apiName] ? this.state.workOrder[field.apiName] : '---'}</div>
                                    </div>
                                </div>
                            )
                        })
                        :
                        <></>
                        }
                    </div>
                    <div className='mt-5'>
                        <div className={this.state.workOrder.Safety_Audit_End__c ? 'd-none' : ''}>
                            <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.finishOnClick()}>Finish Audit</button>
                        </div>
                        <div className={this.state.workOrder.Safety_Audit_End__c ? '' : 'd-none'}>
                            <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.saveFields('end')}>Audit Completed</button>
                        </div>

                        <div className="d-flex justify-content-between mt-3">
                            <button className="btn btn-outline" type="button" onClick={() => this.cancelOnClick()}>Cancel</button>
        
                            <div className='text-right'>
                                <button className={this.state.viewMode === 'auditEdit' ? "d-none" : "btn btn-outline"} type="button" onClick={() => this.changeViewMode('auditEdit')}>Edit</button>
                                <button className={this.state.viewMode === 'auditEdit' ? "btn btn-outline" : "d-none"} type="button" onClick={() => this.saveOnClick()}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};
export default connect(mapStateToProps)(SafetyAudit);